import clsx from "clsx";
import { ShieldHalf } from "lucide-react";

import { simulatedAccess, userIsFPEmployee } from "@/util";

type SimulatePermissionsMenuItemProps = {
  onOpen: () => void;
};

export const SimulatePermissionsMenuItem = ({
  onOpen,
}: SimulatePermissionsMenuItemProps) => {
  if (!userIsFPEmployee()) {
    return null;
  }

  const simulating = simulatedAccess() !== null;

  return (
    <button
      onClick={onOpen}
      className="flex w-full cursor-pointer items-center gap-2 rounded-md p-2 text-left hover:bg-gray-100 focus:bg-gray-100"
    >
      <span
        className={clsx("flex-shrink-0", simulating && "text-status-warning")}
      >
        <ShieldHalf size={18} />
      </span>
      <span
        className={clsx(
          "block",
          simulating ? "text-status-warning" : "text-textDefault",
        )}
      >
        {simulating ? "Simulating permissions" : "Simulate permissions"}
      </span>
    </button>
  );
};
